import { type QueryClient } from "@tanstack/react-query";

// 動的 import したモジュールの型が取れないため any 前提で扱う。any 系ルールは oxlint、
// unsafe 系（型情報が要る）は eslint が担当するため、抑制を両方に分けて書く必要がある
/* oxlint-disable typescript/no-explicit-any */
/* eslint-disable @typescript-eslint/no-unsafe-assignment */
/* eslint-disable @typescript-eslint/no-unsafe-return */
/* eslint-disable @typescript-eslint/no-unsafe-call */
export const convert = (queryClient: QueryClient) => (m: any) => {
  const { loader, action, default: Component, ...rest } = m;
  return {
    ...rest,
    // clientLoader/clientAction は framework mode の概念。data mode は v7 でも loader/action が正
    loader: loader?.(queryClient),
    action: action?.(queryClient),
    Component,
  };
};
